import React from "react";
import { CheckCircleIcon } from "@heroicons/react/24/solid";
import { NotificationsType } from "../src/types";

function NotificationComponent({ content, color }: NotificationsType) {
  return (
    <div className={`rounded-md bg-${color}-50 p-4`}>
      <div className="flex">
        <div className="flex-shrink-0">
          <CheckCircleIcon
            className={`h-5 w-5 text-${color}-400`}
            aria-hidden="true"
          />
        </div>
        <div className="ml-3">
          <p className={`text-sm font-medium text-${color}-800`}>{content}</p>
        </div>
      </div>
    </div>
  );
}

export default NotificationComponent;
